import { useTranslation } from 'react-i18next'
import { TimeTrackingApproval } from '@/api/model'
import { useTimeTrackingEntries } from '../hooks/useTimeTrackingEntries'
import { TimeTrackingEntriesTable } from './TimeTrackingEntriesTable'

interface Props {
  serviceModuleId: number
}

/**
 * "Approvals" section of the "all time entries" page: a separate list of **only the
 * open** (`Pending`) entries to approve/reject — independent of the filters of the
 * full list below (like the old portal, which had a separate table for it). Since both
 * lists use the same query-key prefix, an approval automatically refreshes the full
 * list too.
 */
export function TimeTrackingApprovalsSection({ serviceModuleId }: Props) {
  const { t } = useTranslation('service-modules-timetracking')
  const entries = useTimeTrackingEntries(serviceModuleId, { approval: TimeTrackingApproval.Pending })

  return (
    <div className="flex flex-col gap-2">
      <h2 className="text-lg font-semibold">{t('timetracking.approvalsSection')}</h2>
      <TimeTrackingEntriesTable entries={entries} />
    </div>
  )
}
